import { connect } from 'react-redux';
import { uniqueId } from 'lodash';
import View from './AccountsOverviewView';
import { currentClientId } from '../../../AdvWorkflow/AdvWorkflowSelector';
import {
  accountsOverviewSelector,
  noDeletedAccountsSelector,
  isEmptyStateSelector,
} from './AccountsOverviewSelector';
import { accountsSelector } from './AccountsStepSelector';
import { EDIT_ACCOUNT, DELETE_ACCOUNT } from './AccountsOverviewMenuOptions';
import deleteAccount from './AccountsOverviewActions';
import { setViewId, setDraftAccount } from './AccountsStepActions';
import { EDIT, ADD } from './AccountsStepViews';
import { BASE_ACCOUNT } from '../../AccountsWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  accountsList: accountsOverviewSelector(state, ownProps),
  graphAccounts: accountsSelector(state, ownProps),
  isEmptyState: isEmptyStateSelector(state, ownProps),
  noDeletedAccounts: noDeletedAccountsSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  onMenuOptionClicked: (workflowId, clientId, id, graphAccounts) => menuOption => () => {
    switch (menuOption) {
      case EDIT_ACCOUNT:
        const selectedAcc = graphAccounts.find(
          ({ AccountId, frontEndId }) => AccountId === id || frontEndId === id,
        );
        dispatch(
          setDraftAccount(
            {
              ...selectedAcc,
              OwnerModel: (selectedAcc.OwnerModel ?? []).map(owner => ({
                ...owner,
                fieldKey: uniqueId(),
                percent: (owner.Percentage * 100).toString(),
              })),
            },
            workflowId,
            clientId,
          ),
        );
        dispatch(setViewId(EDIT, workflowId, clientId));
        break;
      case DELETE_ACCOUNT:
        dispatch(deleteAccount(graphAccounts, id, workflowId, clientId));
        break;
      default:
    }
  },
  filterDeletedDebtAccounts: graphObject => ({
    DebtAccounts: graphObject.DebtAccounts.filter(({ IsDeleted }) => IsDeleted),
  }),
  onAddAccount: (workflowId, clientId) => () => {
    dispatch(setDraftAccount(BASE_ACCOUNT, workflowId, clientId));
    dispatch(setViewId(ADD, workflowId, clientId));
  },
});

const AccountsOverviewContainer = connect(mapStateToProps, mapDispatchToProps)(View);

export default AccountsOverviewContainer;
